import { gql as t } from "@apollo/client";
import { LoginAccountFragment as i } from "../fragment/account.js";
const r = t`
  mutation ProcessEmailRegister($input: ProcessEmailRegisterInput!) {
    processEmailRegister(input: $input) {
      ...LoginAccount
    }
  }
  ${i}
`;
export {
  r as default
};
//# sourceMappingURL=processEmailRegister.js.map
